import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'redux/store';
import { selectAppLanguage } from 'redux/selectors/userSettings';

// Applies the user's persisted language preference to i18next. This is the
// only place that calls changeLanguage: the preference lives in redux, every
// reader goes through selectAppLanguage, and a control that changes it
// persists the new value rather than touching i18next itself.
//
// NOTE: `i18n` must NOT be a dependency of the effect. Since react-i18next
// 16.3 useTranslation returns a wrapper object that is rebuilt on every
// language change, so an effect that both depends on `i18n` and calls
// changeLanguage re-triggers itself and overwrites whatever it just applied.
export const useApplyAppLanguage = (): void => {
  const { i18n } = useTranslation();
  const language = useAppSelector(selectAppLanguage);

  useEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
};
